import React from 'react';

import Footer from 'app/modules/Layout/Footer';
import ErrorBoundary from 'app/widgets/ErrorBoundary';
import PromotionModal from 'app/widgets/PromotionModal/ModalContent';

import Content from './ContentDeferred';

const LandingPage = () => {
  return (
    <>
      <ErrorBoundary>
        <PromotionModal />
        <Content />
        <Footer />
      </ErrorBoundary>
    </>
  );
};

export default LandingPage;
